<template>
  <div class="enterpriseSetting">
    <van-nav-bar
      left-arrow
      title="企业信息"
      @click-left="onClickLeft"
    />
    <div class="main">
      <van-cell
        v-for="(i,index) in enterpriseSetting"
        :key="i.name"
        :title="i.name"
        :value="i.value||i.unSetting"
        is-link
        size="large"
        title-class="title"
        value-class="sub-title"
        @click="showinfo(index)"
      />
      <!-- 企业基本信息 -->
      <com-popup
        :init-form-data.sync="form"
        :visible.sync="enterpriseSetting[0].show"
        title="设置企业基本信息"
        @submitFormSuccess="submitFormSuccessFn"
      >
        <van-form ref="harvestForm" class="harvest-form" label-width="90px">
          <van-cell-group class="item-warp block-box">
            <van-field v-model="form.name" disabled label="企业名称" placeholder="请输入企业名称" />
            <van-field v-model="form.legalPerson" :clearable="true" label="法人" placeholder="请输入法人名称" />
            <van-field
              v-model="form.mobile"
              :clearable="true"
              :rules="[{validator:validatorPhone,message: '请输入正确的手机号'}]"
              label="法人电话"
              name="mobile"
              placeholder="请输入法人电话"
            />
            <van-field v-model="form.uscCode" :clearable="true" label="统一社会信用代码" placeholder="请输入统一社会信用代码" />
            <van-field v-model="form.address" :clearable="true" label="地址" placeholder="请输入有效地址" />
          </van-cell-group>
        </van-form>
      </com-popup>
      <!-- 企业简介 -->
      <com-popup
        :init-form-data.sync="form"
        :visible.sync="enterpriseSetting[1].show"
        title="设置企业简介"
        @submitFormSuccess="submitFormSuccessFn"
      >
        <van-cell-group class="item-warp block-box">
          <van-field
            v-model="form.profile"
            autosize
            label="简介"
            maxlength="200"
            placeholder="请输入留言"
            rows="4"
            show-word-limit
            type="textarea"
          />
        </van-cell-group>
      </com-popup>
      <!-- 环境图片 -->
      <com-popup
        :init-form-data.sync="form"
        :visible.sync="enterpriseSetting[2].show"
        title="环境图片"
        @submitFormSuccess="submitFormSuccessFn"
      >
        <van-cell-group class="item-warp ">
          <div class="img-box">
            <div class="title">
              建议上传手机横屏拍摄的照片，最多上传5张
            </div>
            <wh-upload v-model="form.pic" :max-count="5" />
          </div>
        </van-cell-group>
      </com-popup>
      <!-- 企业资质 -->
      <com-popup
        :init-form-data.sync="form"
        :visible.sync="enterpriseSetting[3].show"
        title="企业资质"
        @submitFormSuccess="submitFormSuccessFn"
      >
        <van-cell-group class="item-warp" style="height: 100%">
          <div class="img-box-company">
            <span>营业执照</span>
            <wh-upload v-model="form.uscPic" :max-count="6" />
          </div>
          <div class="img-box-company">
            <span>经营许可证</span>
            <wh-upload v-model="form.businessPic" :max-count="1" />
          </div>
          <div class="img-box-company">
            <span>生产许可证</span>
            <wh-upload v-model="form.productPic" :max-count="1" />
          </div>
          <div class="img-box-company">
            <span>防疫许可证</span>
            <wh-upload v-model="form.epidemicPic" :max-count="1" />
          </div>
        </van-cell-group>
      </com-popup>
      <!-- 客服电话 -->
      <com-popup
        :init-form-data.sync="form"
        :visible.sync="enterpriseSetting[4].show"
        title="客服电话"
        @submitFormSuccess="submitFormSuccessFn"
      >
        <van-cell-group class="item-warp block-box">
          <van-field v-model="form.serviceTel" label="客服电话" placeholder="请输入客服电话" />
        </van-cell-group>
      </com-popup>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import { deepClone } from '@/utils/tool'
import ComPopup from '@/views/basic/components/ComPopup'
import WhUpload from '@/components/public/WhUpload/WhUpload'

export default {
  components: { ComPopup, WhUpload },
  data() {
    return {
      enterpriseSetting: [
        {
          name: '企业基本信息',
          value: '已设置',
          unSetting: '未设置',
          show: false
        },
        {
          name: '企业简介',
          value: '已设置',
          unSetting: '未设置',
          show: false
        },
        {
          name: '环境图片',
          value: '已上传',
          unSetting: '未上传',
          show: false
        },
        {
          name: '企业资质',
          value: '已上传',
          unSetting: '请补全',
          show: false
        },
        {
          name: '客服电话',
          value: '',
          unSetting: '未设置',
          show: false
        }
      ],
      companyInfo: {},
      form: {},
      rules: {
        mobile: [
          { required: true, message: '请输入法人电话' },
          { validator: this.validator, trigger: 'change', message: '采收量不能等于零' }
        ]
      }
    }
  },
  mounted() {
    this.getCompany()
  },
  methods: {
    deepClone,
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val)
    },
    getCompany() {
      api.getCompany().then(res => {
        this.companyInfo = res.data
        this.enterpriseSetting[0].value = this.companyInfo.name ? '已设置' : ''
        this.enterpriseSetting[1].value = this.companyInfo.profile ? '已设置' : ''
        this.enterpriseSetting[2].value = this.companyInfo.pic && this.companyInfo.pic.length ? '已上传' : ''
        this.enterpriseSetting[3].value = this.companyInfo.uscPic && this.companyInfo.uscPic.length ? '已上传' : ''
        this.enterpriseSetting[4].value = this.companyInfo.serviceTel
      })
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    showinfo(i) {
      this.enterpriseSetting[i].show = true
      this.form = this.deepClone(this.companyInfo)
    },
    submitFormSuccessFn(flag) {
      if (flag) {
        this.getCompany()
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .van-cell {
  margin-bottom: 16px;
  padding: 16px 16px;
}
.enterpriseSetting {
  background-color: #f3f7f8;
  width: 100%;
  height: 100%;
  .main {
    padding: 10px 16px 0;
  }
  .title {
    color: rgba(37, 50, 86, .89);
    font-size: 14px;
    font-weight: bold;
  }
  .sub-title {
    color: #333;
    font-size: 14px;
  }
  .item-warp {
    padding: 10px 16px 0;
    background-color: #f3f7f8;
    height: calc(100% - 46px);
    .img-box-company {
      width: 100%;
      display: flex;
      flex-direction: column;
      background-color: #fff;
      font-weight: normal;
      padding-bottom: 20px;
      align-items: center;
      span {
        display: inline-block;
        text-align: center;
        padding-bottom: 20px;
        margin-bottom: 40px;
        width: 100%;
        font-size: 14px;
        color: #333;
        background-color: #f3f7f8;
        position: relative;
        &::after {
          content: '';
          width: 25px;
          height: 2px;
          position: absolute;
          background-color: #41c19e;
          bottom: 14px;
          left: calc(50% - 12px);
        }
      }
    }
    .second {
      margin-top: 20px;
      > div:first-child {
        margin-right: 10px;
      }
    }
  }
  .img-box {
    margin: 0 auto;
    width: 96%;
    background-color: #fff;
    padding: 20px;
    .title {
      width: 100%;
      text-align: center;
      color: #999;
      font-weight: normal;
      padding-bottom: 20px;
    }
  }
}
.list-message {
  display: grid;
}
</style>
